import React, {type FC} from 'react';
import {
  Slide,
  toast as toastify,
  ToastContainer as ToastifyContainer,
  type ToastContent,
  type ToastOptions,
} from 'react-toastify';

import {Icon} from '../../../components/Icon';

export const ToastContainer: FC = () => {
  return (
    <ToastifyContainer
      icon={false}
      position="top-right"
      hideProgressBar={true}
      className="toast-container"
      toastClassName="toast"
      transition={Slide}
      closeButton={({closeToast}) => (
        <div className="close-toast">
          <Icon
            name="close"
            role="button"
            aria-label="Dismiss message"
            onClick={closeToast}
          />
        </div>
      )}
    />
  );
};

export function toast(text: ToastContent, options?: ToastOptions): void {
  toastify(text, options);
}
